// @ts-check
import { h } from 'preact';

import StatusLabel from '../StatusLabel';

const { _n, sprintf } = wp.i18n;

/**
 * @param {object} props
 * @param {import('../../types').PlotNumber[]} props.plotNumbers
 * @param {import('../../types').Status} props.status
 * @returns
 */
export default function PlotNumbersStatusCount({ plotNumbers, status }) {
	const count = plotNumbers.filter(p => p.status.value === status.value).length;

	if (count > 0) {
		return <div>{sprintf(_n('%d house', '%d houses', count), count)} <strong><StatusLabel status={status}>{status.label.toLocaleLowerCase()}</StatusLabel></strong></div>;
	}
}
